import { render, staticRenderFns } from "./GlobalNavigationBar.vue?vue&type=template&id=301413ca&scoped=true&name=global-navigation-bar&"
import script from "./GlobalNavigationBar.vue?vue&type=script&lang=js&"
export * from "./GlobalNavigationBar.vue?vue&type=script&lang=js&"
import style0 from "./GlobalNavigationBar.vue?vue&type=style&index=0&id=301413ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301413ca",
  null
  
)

/* custom blocks */
import block0 from "./GlobalNavigationBar.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports